import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

import FooterSlice from './FooterSlice/FooterSlice';
import PreorderSlice from './PreorderSlice/PreorderSlice';
import OrderSlice from './OrderSlice/OrderSlice';
import PublicFormSlice from './PublicFormSlice/PublicFormSlice';
import LanguageSlice from './LanguageSlice/LanguageSlice';
import DonationSlice from './DonationSlice/DonationSlice';
import AppMiddleware from './Middleware';

export const appReducer = combineReducers({
	footer: FooterSlice.reducer,
	preorder: PreorderSlice.reducer,
	order: OrderSlice.reducer,
	publicForm: PublicFormSlice.reducer,
	language: LanguageSlice.reducer,
	donation: DonationSlice.reducer,
});

const store = configureStore({
	reducer: appReducer,
	middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(AppMiddleware),
});

export { AppMiddleware as appMiddleware };
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

export default store;
